var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudflare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6572_133004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8899 12.0019C12.3172 10.9919 11.7346 10.5257 11.1519 10.5257L5.40267 10.4481C5.24729 10.4481 5.24729 10.215 5.44152 10.1761L11.2684 10.0984C11.9288 10.0596 12.7057 9.51575 12.9388 8.81652C12.9388 8.81652 13.3272 8.00076 13.2884 7.88422C13.1202 7.07284 12.6893 6.33951 12.0623 5.79775C11.4353 5.256 10.6472 4.93602 9.82002 4.88736C8.99282 4.83871 8.17265 5.06407 7.48646 5.52858C6.80028 5.99309 6.28634 6.67084 6.02421 7.45691C4.54806 6.48577 2.99422 7.80653 3.34384 9.24383C1.47923 9.36037 0.81885 11.0307 1.01308 12.0407C1.01308 12.0796 1.05193 12.1184 1.12962 12.1184H11.7734C11.8123 12.1184 11.8899 12.0796 11.8899 12.0019Z",
    fill: "#F38020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8331 8.03901C13.6778 8.03901 13.6001 8.00016 13.5612 8.07785L13.367 8.89362C13.1728 9.51515 13.4835 10.059 14.1439 10.0978L15.387 10.1755C15.5424 10.1755 15.5424 10.4086 15.3481 10.4475L14.0662 10.4863C12.6678 10.6417 12.2793 12.0013 12.2793 12.0013C12.2793 12.079 12.2793 12.1178 12.357 12.1178H16.7466L16.8631 12.0401C16.9952 11.5721 17.017 11.0798 16.9268 10.602C16.8366 10.1241 16.6369 9.67363 16.3433 9.28595C16.0497 8.89826 15.6703 8.5839 15.2347 8.36755C14.7992 8.15119 14.3194 8.03874 13.8331 8.03901Z",
    fill: "#FAAE40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6572_133004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudflare);
export default __webpack_public_path__ + "static/media/Cloudflare.5855881181f6221242cc1278b769f813.svg";
export { ForwardRef as ReactComponent };